<nb-card style="min-height: 600px;max-height: 600px;min-width: 1300px;max-width:1300px;">
  <nb-card-header>
    <div class="row">
      <div class="col-sm-10">
      <h6>State Information</h6>
      </div>
      <div class="col-sm-2">
        <button (click)="ref.close()" nbButton size="tiny" status="primary" style="float:right;"
          type="button" id="Back" name="Back">
          &nbsp;Close
        </button>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div [nbSpinner]="!checkObj(resultObject)" nbSpinnerSize="giant" nbSpinnerStatus="warning"
      style="min-height: 400px;">

      <!-- <h6 *ngIf="checkObj(resultObject)">{{appRiskInfoObject.appType}} | Edition {{resultObject.editionDate| date :
    'MM/yy'}} | {{appRiskInfoObject.state}} State Combination Tables </h6> -->
      <div class="card" *ngIf="checkObj(resultObject)">
        <div class="card-header" style="padding: 0.5rem 1.25rem;" >
          <div class="row" >
            <div class="col-sm-3">
              <div class="form-group">
                <label for="state">State</label>
                <select (change)="lobOrStateChange(appRiskInfoObject);" [(ngModel)]="appRiskInfoObject.state"
                  class="form-control form-control-sm " id="state" name="state">
                  <option disabled selected value=null>--- Choose an Option ---</option>
                  <option *ngFor="let s of statesList" [value]="s.abbreviation">{{s.abbreviation}}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="state">LOB</label>
                <select [(ngModel)]="appRiskInfoObject.appType" (change)="lobOrStateChange(appRiskInfoObject);"
                  class="form-control form-control-sm " id="state" name="state">
                  <option disabled selected value=null>--- Choose an Option ---</option>
                  <option *ngFor="let l of lobMasterList" [value]="l.description">{{l.description}}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-3" *ngIf="!resultObject.errorFlag">
              <label> Rate Edition</label>
              <select name="editionDate" [(ngModel)]="appRiskInfoObject.rateFillingId"
                (ngModelChange)="onChangeRateFilling(appRiskInfoObject,rateFillingList);"
                class="form-control form-control-sm " id="tod1" name="tod1">
                <option disabled selected ngValue=null>--- Choose an Option ---</option>
                <option *ngFor="let l of rateFillingList" [ngValue]="l.rateFillingId">{{l.editionDate | date :
                  'MM/yy'}}
                </option>
              </select>
            </div>
            <div class="col-sm-3" *ngIf="!resultObject.errorFlag">
              <label>Approval Date</label>
              <input class="form-control" [disabled]="true" [(ngModel)]="approvalDate" type="date"
                placeholder="MM/DD/YYYY" id="approvalDate" name="approvalDate">
            </div>
          </div>
        </div>
        <div class="card-body">

          <nb-tabset (changeTab)="onChangeTab($event)" *ngIf="checkObj(resultObject) && !resultObject.errorFlag">
            <nb-tab tabTitle="E&O Rating Tables" *ngIf="resultObject.eoTabEnabled"
              [active]="selectedTab == 'E&O Rating Tables'">
              <div class="row" *ngIf="selectedTab == 'E&O Rating Tables'">
                <div class="col-sm-6" *ngFor="let s of eoDetailsList">
                  <div>
                    <ngx-view-dynamic-table
                      [childObject]="{labelId:s.labelId,entity:s.moduleName,state:appRiskInfoObject.state,appType:appRiskInfoObject.appType,rateFillingId:1,disableOption:true,dynamicTabelList:s.dynamicTabelList,patchedValueList:s.patchedValueList,description:s.description}">
                    </ngx-view-dynamic-table>
                  </div>
                </div>
              </div>
            </nb-tab>
            <nb-tab tabTitle="Cyber Rating Tables" *ngIf="resultObject.cyberTabEnabled"
              [active]="selectedTab == 'Cyber Rating Tables'">
              <div class="row" *ngIf="selectedTab == 'Cyber Rating Tables'">
                <div class="col-sm-6" *ngFor="let s of cyberDetailsList">
                  <div>
                    <ngx-view-dynamic-table
                      [childObject]="{labelId:s.labelId,entity:s.moduleName,state:appRiskInfoObject.state,appType:appRiskInfoObject.appType,rateFillingId:1,disableOption:true,dynamicTabelList:s.dynamicTabelList,patchedValueList:s.patchedValueList,description:s.description}">
                    </ngx-view-dynamic-table>
                  </div>
                </div>
              </div>
            </nb-tab>
            <nb-tab tabTitle="Optional Coverage Tables" *ngIf="resultObject.optionalTabEnabled"
              [active]="selectedTab == 'Optional Coverage Tables'">
              <div class="row" *ngIf="selectedTab == 'Optional Coverage Tables'">
                <div class="col-sm-6" *ngFor="let s of optDetailsList">
                  <div>
                    <ngx-view-dynamic-table
                      [childObject]="{labelId:s.labelId,entity:s.moduleName,state:appRiskInfoObject.state,appType:appRiskInfoObject.appType,rateFillingId:1,disableOption:true,dynamicTabelList:s.dynamicTabelList,patchedValueList:s.patchedValueList,description:s.description}">
                    </ngx-view-dynamic-table>
                  </div>

                </div>
              </div>
            </nb-tab>
            <nb-tab tabTitle="Minimum Premium Tables" *ngIf="resultObject.minimuTabEnabled"
              [active]="selectedTab == 'Minimum Premium Tables'">
              <div class="row" *ngIf="selectedTab == 'Minimum Premium Tables'">
                <div class="col-sm-6" *ngFor="let s of minDetailsList">
                  <div>
                    <ngx-view-dynamic-table
                      [childObject]="{labelId:s.labelId,entity:s.moduleName,state:appRiskInfoObject.state,appType:appRiskInfoObject.appType,rateFillingId:1,disableOption:true,dynamicTabelList:s.dynamicTabelList,patchedValueList:s.patchedValueList,description:s.description}">
                    </ngx-view-dynamic-table>
                  </div>
                </div>
              </div>
            </nb-tab>

            <nb-tab tabTitle="Gross Revenue Mapping" *ngIf="appRiskInfoObject.appType === 'RESTD'"
              [active]="selectedTab == 'Gross Revenue Mapping'">
              <div class="row" *ngIf="selectedTab == 'Gross Revenue Mapping'">
                <div class="col-sm-12">
                  <div>
                    <ngx-view-gross-revenue
                      [childObject]="{labelId:labelId,entity:moduleName,state:appRiskInfoObject.state,appType:appRiskInfoObject.appType,rateFillingId:appRiskInfoObject.rateFillingId}">
                    </ngx-view-gross-revenue>
                  </div>
                </div>
              </div>
            </nb-tab>

            <nb-tab tabTitle="Aop Factor" *ngIf="appRiskInfoObject.appType === 'ACSTD'"
              [active]="selectedTab == 'Aop Factor'">
              <div class="row" *ngIf="selectedTab == 'Aop Factor'">
                <div class="col-sm-12">
                  <div>
                    <ngx-view-ac-std-aop-factor
                      [childObject]="{labelId:labelId,entity:moduleName,state:appRiskInfoObject.state,appType:appRiskInfoObject.appType,rateFillingId:appRiskInfoObject.rateFillingId}">
                    </ngx-view-ac-std-aop-factor>
                  </div>
                </div>
              </div>
            </nb-tab>

            <nb-tab tabTitle="IRM"
              *ngIf="appRiskInfoObject.appType === 'ACSTD' || appRiskInfoObject.appType === 'RESTD'"
              [active]="selectedTab == 'IRM'">
              <div *ngIf="selectedTab == 'IRM'">
                <div class="row">
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label>Min</label>
                      <input type="number" class="form-control" [(ngModel)]="object.irmMin" [disabled]="true">
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label>Max</label>
                      <input type="number" class="form-control" [(ngModel)]="object.irmMax" [disabled]="true">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <!-- <textarea [(ngModel)]="irmJsonString" class="form-control form-control-sm" id="desc" rows="12"
              type="text"></textarea> -->
                    <json-editor [options]="editorOptions" [data]="irmJsonString"></json-editor>
                  </div>
                </div>
              </div>
            </nb-tab>





            <nb-tab tabTitle="Forms List" [active]="selectedTab == 'Forms List'">
              <div class="row">
                <div class="col-md-6">
                  <table class=" table  table-bordered  table-sm">
                    <thead>
                      <tr>
                        <th>Documents</th>
                        <th style="width: 50%;">Options</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>

                        <td style="text-align: center;"><strong> Rate Filling</strong></td>
                        <td *ngIf="!templateRateFillingFlag" [nbSpinner]="fileStatus" nbSpinnerSize="giant"
                          nbSpinnerStatus="warning">
                          <input #myInput class="form-control form-control-sm" type="file" id="ratefile"
                            accept="application/pdf"
                            (change)="handleFileInputddt($event.target.files,appRiskInfoObject.rateFillingId,'RateFilling')">

                        </td>
                        <td *ngIf="templateRateFillingFlag">
                          <i class="fa  fa-eye" style="margin-right: 12px;" disabled="docButtonDisable"
                            (click)="!docButtonDisable?previewScannedDocuments(0,rateFillingDocumentId,previewModal):false"></i>

                          <i class="fa fa-download" style="margin-right: 12px;" disabled="docButtonDisable"
                            (click)="!docButtonDisable?previewScannedDocuments(1,rateFillingDocumentId,previewModal):false"></i>

                          <i class="fa fa-trash" disabled="docButtonDisable"
                            (click)="!docButtonDisable?deleteScannedDocument(templateData,rateFillingDocumentId, 'RateFilling'):false"></i>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center;"><strong>Form List</strong></td>
                        <td *ngIf="!templateFormsListFlag" [nbSpinner]="formFileStatus" nbSpinnerSize="giant"
                          nbSpinnerStatus="warning">

                          <input #myInput class="form-control form-control-sm" type="file" id="Formfile"
                            accept="application/pdf"
                            (change)="handleFileInputddt($event.target.files,appRiskInfoObject.rateFillingId,'FormList')">

                        </td>
                        <td *ngIf="templateFormsListFlag">
                          <i class="fa  fa-eye" style="margin-right: 12px;" disabled="docButtonDisable"
                            (click)="!docButtonDisable?previewScannedDocuments(0,formListDocumentId,previewModal):false"></i>

                          <i class="fa fa-download" style="margin-right: 12px;" disabled="docButtonDisable"
                            (click)="!docButtonDisable?previewScannedDocuments(1,formListDocumentId,previewModal):false"></i>

                          <i class="fa fa-trash" disabled="docButtonDisable"
                            (click)="!docButtonDisable?deleteScannedDocument(templateData,formListDocumentId, 'FormList'):false"></i>

                        </td>
                      </tr>
                    </tbody>

                  </table>

                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-md-6">
                  <table class=" table  table-bordered  table-sm">
                    <thead>
                      <tr>
                        <th>Optional Endorsements</th>
                        <th>Edition</th>
                        <th>Options</th>
                      </tr>
                      <tr>
                        <td>
                          <input [(ngModel)]="optionalSearch.endorsementDetail" aria-describedby="inputGroup-sizing-sm"
                            id="endorsementDetail" name="endorsementDetail" aria-label="Sizing example input"
                            class="form-control" type="search" (ngModelChange)="f=1">
                        </td>
                        <td>
                          <input [(ngModel)]="optionalSearch.editionStartDate" aria-describedby="inputGroup-sizing-sm"
                            id="editionStartDate" name="editionStartDate" aria-label="Sizing example input"
                            class="form-control" type="search" (ngModelChange)="f=1">
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let s of OptionalList | filterBy:optionalSearch |  paginate: { id:'optionalDetails', itemsPerPage: 15, currentPage: f }; let i=index;">
                        <td><span data-toggle="tooltip" title="{{s.endorsementDetail}}">{{s.endorsementDetail |
                            slice:0:44}}<span *ngIf="s.endorsementDetail.length>44">...</span></span></td>
                        <td>{{s.editionStartDate}}</td>
                        <td>
                          <i class="fa  fa-eye" style="margin-right: 12px;" disabled="docButtonDisable"
                            (click)="!docButtonDisable?onPreviewScannedDoc(0,s.templateId,previewModal):false"></i>

                          <i class="fa fa-download" disabled="docButtonDisable"
                            (click)="!docButtonDisable?onPreviewScannedDoc(1,s.templateId,previewModal):false"></i>

                        </td>


                      </tr>
                      <tr *ngIf="(OptionalList | filterBy: optionalSearch).length === 0">
                        <td colspan="3">No Data Found</td>
                      </tr>
                    </tbody>
                    <tfoot *ngIf="OptionalList.length>15">
                      <tr>
                        <td colspan="3">
                          <p class="text-center">
                            <pagination-controls id="optionalDetails" (pageChange)="f = $event" autoHide="true"
                              directionLinks="true" previousLabel="" nextLabel="">
                            </pagination-controls>
                          </p>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <div class="col-md-6">

                  <table class=" table table-bordered   table-sm">
                    <thead>
                      <tr>
                        <th>Mandatory Endorsements</th>
                        <th>Edition</th>
                        <th>Options</th>
                      </tr>
                      <tr>
                        <td>
                          <input [(ngModel)]="mandatorySearch.endorsementDetail" aria-describedby="inputGroup-sizing-sm"
                            id="endorsementDetail" name="endorsementDetail" aria-label="Sizing example input"
                            class="form-control" type="search" (ngModelChange)="p=1">
                        </td>
                        <td>
                          <input [(ngModel)]="mandatorySearch.editionStartDate" aria-describedby="inputGroup-sizing-sm"
                            id="editionStartDate" name="editionStartDate" aria-label="Sizing example input"
                            class="form-control" type="search" (ngModelChange)="p=1">
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>

                      <tr
                        *ngFor="let s of MandatoryList | filterBy:mandatorySearch | paginate: { id:'mandatoryDetails',itemsPerPage: 15, currentPage: p }; let k=index;">
                        <td><span data-toggle="tooltip" title="{{s.endorsementDetail}}">{{s.endorsementDetail |
                            slice:0:44}}<span *ngIf="s.endorsementDetail.length>44">...</span></span></td>
                        <td>{{s.editionStartDate}}</td>
                        <td>
                          <i class="fa  fa-eye" style="margin-right: 12px;" disabled="docButtonDisable"
                            (click)="!docButtonDisable?onPreviewScannedDoc(0,s.templateId,previewModal):false"></i>

                          <i class="fa fa-download" disabled="docButtonDisable"
                            (click)="!docButtonDisable?onPreviewScannedDoc(1,s.templateId,previewModal):false"></i>

                        </td>


                      </tr>
                      <tr *ngIf="(MandatoryList | filterBy: mandatorySearch).length === 0">
                        <td colspan="3">No Data Found</td>
                      </tr>
                    </tbody>
                    <tfoot *ngIf="MandatoryList.length>15">
                      <tr>
                        <td colspan="3">
                          <p class="text-center">
                            <pagination-controls id="mandatoryDetails" (pageChange)="p = $event" autoHide="true"
                              directionLinks="true" previousLabel="" nextLabel="">
                            </pagination-controls>
                          </p>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>


              <div class="row">

                <div class="col-md-6">

                  <table class=" table  table-bordered  table-sm">
                    <thead>
                      <tr>
                        <th>Selectable Endorsements</th>
                        <th>Edition</th>
                        <th>Options</th>
                      </tr>
                      <tr>
                        <td>
                          <input [(ngModel)]="selectableSearch.endorsementDetail"
                            aria-describedby="inputGroup-sizing-sm" id="endorsementDetail" name="endorsementDetail"
                            aria-label="Sizing example input" class="form-control" type="search" (ngModelChange)="q=1">
                        </td>
                        <td>
                          <input [(ngModel)]="selectableSearch.editionStartDate" aria-describedby="inputGroup-sizing-sm"
                            id="editionStartDate" name="editionStartDate" aria-label="Sizing example input"
                            class="form-control" type="search" (ngModelChange)="q=1">
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>

                      <tr
                        *ngFor="let s of OpenList | filterBy:selectableSearch | paginate: {id: 'documentDetails',  itemsPerPage: 15, currentPage: q }; let j=index;">
                        <td><span data-toggle="tooltip" title="{{s.endorsementDetail}}">{{s.endorsementDetail |
                            slice:0:44}}<span *ngIf="s.endorsementDetail.length>44">...</span></span></td>
                        <td>{{s.editionStartDate}}</td>
                        <td>
                          <i class="fa  fa-eye" style="margin-right: 12px;" disabled="docButtonDisable"
                            (click)="!docButtonDisable?onPreviewScannedDoc(0,s.templateId,previewModal):false"></i>

                          <i class="fa fa-download" disabled="docButtonDisable"
                            (click)="!docButtonDisable?onPreviewScannedDoc(1,s.templateId,previewModal):false"></i>
                        </td>
                      </tr>
                      <tr *ngIf="(OpenList | filterBy: selectableSearch).length === 0">
                        <td colspan="3">No Data Found</td>
                      </tr>
                    </tbody>
                    <tfoot *ngIf="OpenList.length>15">
                      <tr>
                        <td colspan="3">
                          <p class="text-center">
                            <pagination-controls id="documentDetails" (pageChange)="q = $event" autoHide="true"
                              directionLinks="true" previousLabel="" nextLabel="">
                            </pagination-controls>
                          </p>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>

              </div>
            </nb-tab>
          </nb-tabset>
        </div>
      </div>
      <h6 class="text-danger text-center" *ngIf="resultObject.errorFlag">There are no rate filings in the selected lob &
        state.</h6>

    </div>
  </nb-card-body>
</nb-card>




<ng-template #previewModal let-data let-ref="dialogRef">
  <nb-card class="modal_size1">
    <nb-card-header>
      <div class="row">
        <div class="col-sm-9">
          <h6>{{endorsementName}}</h6>
        </div>
        <div class="col-sm-3">
          <button (click)="ref.close()" style="float:right;" nbButton size="tiny" status="primary" type="button">
            Close
          </button>
        </div>
      </div>

    </nb-card-header>
    <nb-card-body>
      <div class="col-sm-12">
        <iframe width="100%" height="600" [src]="urlSafe"></iframe>
      </div>
    </nb-card-body>
  </nb-card>
</ng-template>